// src/components/Footer.jsx
import React, { useState } from "react";

function Footer() {
  const [showContactModal, setShowContactModal] = useState(false);
  const APP_STORE_URL = "https://apps.apple.com/us/app/skroop/id6754806438";

  return (
    <>
      <footer className="footer">
        <div className="footer__content">
          <div className="footer__brand">
            <div className="footer__logo-line">
              <img src="/images/skroop_white_transparent_thick.png" alt="Skroop Logo" className="footer__logo" />
              <span className="footer__title">skroop</span>
            </div>
            <p className="footer__tagline">
              Dedicated to the principles of diligence and morality in all aspects of life.
            </p>
            <p className="footer__legal">
              © 2025 A project by The Scrupulous Principle Ltd. All rights reserved. EIN <a href="https://skroop-public-docs.s3.us-east-1.amazonaws.com/IRS+Determination+Letter" target="_blank" rel="noopener noreferrer">33‑4786289</a>.
            </p>
          </div>

          <div className="footer__appstore-wrapper">
            <a
              href={APP_STORE_URL}
              className="footer__appstore"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                if (APP_STORE_URL === "#") {
                  e.preventDefault();
                }
              }}
            >
              <img
                src="/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
                alt="Download on the App Store"
              />
            </a>
          </div>

          <div className="footer__links">
            {/*<div>
              <h4 className="footer__heading">Explore</h4>
              <ul>
                <li><a href="/blog_preview">Blog</a></li>
                <li><a href="/homily_preview">Daily Homily</a></li>
              </ul>
            </div>*/}
            <div>
              <h4 className="footer__heading">Project</h4>
              <ul>
                <li><a href="/about">About</a></li>
                <li>
                  <button onClick={() => setShowContactModal(true)} style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', cursor: 'pointer' }}>
                    Contact
                  </button>
                </li>
                <li><a href="/terms">Terms and Conditions</a></li>
                <li><a href="/privacy">Privacy Policy</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      {/* Contact Modal */}
      {showContactModal && (
        <div className="modal-overlay" onClick={() => setShowContactModal(false)}>
          <div className="login-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowContactModal(false)}>×</button>
            <h2>Contact Us</h2>
            <p style={{ marginTop: '1rem', fontSize: '1rem' }}>
              Please email us at <a href="mailto:support@skroop.org">support@skroop.org</a> for questions or comments.
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default Footer;
